<template>
    <div>
        <!--<v-container fluid style="background: #CCC;" class="d-none d-lg-block px-0 py-0 tituloPres" v-if="proyectosFiltrados(idCotizacion, tipoProyecto.id)">
            <v-row>
                <v-col cols="12" class="py-0">
                    <h3 class="ml-5 my-4">{{ tipoProyecto.fields.nombre }}</h3>
                </v-col>
            </v-row>
        </v-container>-->

        <v-container fluid class="py-0">
            <v-row v-for="(proyecto, key) in proyectosFiltrados(idCotizacion, tipoProyecto.id)" :key="'proyecto-' + key">
                <Divider />
                <Proyecto :tipo-proyecto="tipoProyecto" :proyecto="proyecto"></Proyecto>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import Proyecto from "@/components/Proyecto";
import Divider from "@/components/Divider";

export default {
    name: "TipoProyecto",
    components: {
        Divider,
        Proyecto,
    },
    props: {
        idCotizacion: {
            required: true,
            type: String
        },
        tipoProyecto: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            proyectos: []
        }
    },
    computed: {
        ...mapState(["presentacion"]),
        ...mapGetters(['proyectosFiltrados']),
        windowWidth() {
            return window.innerWidth;
        }
    }
}
</script>
